import { render, staticRenderFns } from "./ReportesBajasTransitoPantalla.vue?vue&type=template&id=34604e98&"
import script from "./ReportesBajasTransitoPantalla.vue?vue&type=script&lang=ts&"
export * from "./ReportesBajasTransitoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('34604e98', component.options)
    } else {
      api.reload('34604e98', component.options)
    }
    module.hot.accept("./ReportesBajasTransitoPantalla.vue?vue&type=template&id=34604e98&", function () {
      api.rerender('34604e98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ReportesBajasTransito/ReportesBajasTransitoPantalla.vue"
export default component.exports